import overview from './overview'
import whiteList from './whiteList'
import storageManagement from './storageManagement'
import autoClean from './autoClean'
export default {
  namespaced: true,
  modules: {
    overview,
    whiteList,
    storageManagement,
    autoClean,
  },
}
